<template>
	<div style="width:500px;height:500px;margin:auto;position:absolute;left:50%;top:50%;margin-left: -250px;margin-top:-250px;text-align: center;">
		<el-row style="margin-bottom: 10px;">
			<el-input placeholder="请输入您的用户名" prefix-icon="el-icon-user" class="login_input_text" v-model="loginid">
			</el-input>
		</el-row>
		<el-row style="margin-bottom: 10px;">
			<el-input placeholder="请输入密码" prefix-icon="el-icon-lock" class="login_input_text" v-model="password" show-password>
			</el-input>
		</el-row>
		<el-row>
			<el-button type="primary" @click="loginUser()" style="width:500px">立即登录</el-button>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginid:'',
				password:''
			};
		},
		
		methods: {
			loginUser(){
				if(!this.loginid){
					this.$message('用户名不能为空')
					return
				}
				if(!this.password){
					this.$message('密码不能为空')
					return
				}
				this.$http.get('user/Login.do?loginId=' + this.loginid + "&loginPwd=" + this.password)
				.then(res=>{
					if(res.data.code == "1"){
						console.log('ok')
						this.$router.push({path:'home/product'})
					}
					else{
						this.$message("用户名或密码错误，请重试")
					}
				})
				.catch(ex=>{
					this.$message(ex.body)
				})
			}
		}
	}
</script>

<style>
</style>
